import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AddCirculars } from 'src/app/_models';

@Injectable({
  providedIn: 'root'
})
export class CircularsServices {
  private url: string = environment.apiUrl;
  constructor(private http: HttpClient) {}

  CreateCirculars(data: FormData) {
    return this.http.post(`${this.url}Circulars/CreateCirculars `, data);
  }
  GetAllCirculars(pageSize: number, pageIndex: number) {
    return this.http.get(`${this.url}Circulars/GetAllCirculars/${pageSize}/${pageIndex}`);
  }
  DeleteCircular(id: number) {
    return this.http.delete(`${this.url}Circulars/DeleteCirculars/${id}`);
  }

  GetCircularById(id: number) {
    return this.http.get(`${this.url}Circulars/GetCirculars/${id}`);
  }

  UpdateCirculars(data: FormData) {
    return this.http.put(`${this.url}Circulars/UpdateCirculars`, data);
  }

  UploadCircularsFile(file: File) {
    const data = new FormData();
    data.append('File', file);
    return this.http.post(`${this.url}Circulars/UploadCircularsFile`, data);
  }
  RemoveFile(id: number) {
    return this.http.delete(`${this.url}Circulars/RemoveFile/${id}`);
  }
  // file Service
  Download(fileName: string) {
    return this.http.get(`${this.url}File/Download/${fileName}`, { responseType: 'blob' });
  }
}
